// Success. Auto-resets after KioskConfig.doneResetMs (driven by App.tsx);
// the "Start over" button lets a visitor leave immediately.

import { Button } from "../components/Button";
import { SuccessCheck } from "../components/Illustrations";
import { KioskShell } from "../components/KioskShell";
import { TicketQr } from "../components/TicketQr";
import { useLang } from "../i18n/LangContext";
import type { KioskState } from "../state/types";
import type { Dispatch } from "./shared";

type Done = Extract<KioskState, { phase: "done" }>;

export function DoneScreen({
  state,
  dispatch,
}: {
  state: Done;
  dispatch: Dispatch;
}) {
  const { t } = useLang();
  return (
    <KioskShell step={4}>
      <div className="screen screen--center">
        <div className="status-badge status-badge--success badge-pop">
          <SuccessCheck />
        </div>
        <h1 className="screen__title">{t("doneTitle")}</h1>
        <p className="screen__subtitle">
          {t("doneOrder", { id: state.orderId })} · {t("doneEnjoy")}
        </p>
        {state.tickets.length > 0 && (
          <div className="done__tickets">
            {state.tickets.map((ticket) => (
              <div className="done__ticket" key={ticket.id}>
                <TicketQr size={180} uniqueCode={ticket.uniqueCode} />
                <span className="done__ticket-number">
                  {ticket.displayTicketNumber}
                </span>
                <span className="done__ticket-type">
                  {ticket.ticketTypeName}
                </span>
              </div>
            ))}
          </div>
        )}
        <Button
          onClick={() => dispatch({ type: "idle-timeout" })}
          variant="secondary"
        >
          {t("startOver")}
        </Button>
      </div>
    </KioskShell>
  );
}
